import { Button, Grid } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import CKEditor from 'ckeditor4-react';
import { Labeled } from 'react-admin';
import { indexOf } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import DialogTitleWithCloseButton from '../../../core/components/DialogTitleWithCloseButton';
import PreviewEmailApi from '../../../core/apis/PreviewEmailApi';
import CircularProgress from '@material-ui/core/CircularProgress';
import RichTextInput from '../../../core/components/inputs/RichTextInput';

/**
 * Email preview dialog for distribution list
 */

const EmailPreviewDialog = ({
  showDialog,
  formData,
  handleDialogToggle,
  resourceUploadId
}) => {
  // Unsubstituted subject and body come from formData
  const { subject, msgBody, selectedItems } = formData;
  const [substitutedSubject, setSubstitutedSubject] = useState();
  const [substitutedBody, setSubstitutedBody] = useState();

  // Current Distribution list item we are previewing
  const [currentItem, setCurrentItem] = useState(0);
  const item = selectedItems[currentItem];

  // Perform the variable substitution by calling the API
  const [loading, setLoading] = useState(false);
  const previewItem = useCallback(
    async item => {
      if (item) {
        setLoading(true);

        const data = await PreviewEmailApi.previewforSavedDL(
          subject,
          msgBody,
          item.email,
          item.fundId,
          item.investors.length === 1 ? item.investors[0].id : '*',
          false,
          resourceUploadId
        );

        setSubstitutedSubject(data.subject);
        setSubstitutedBody(data.msgBody);
        setLoading(false);
      }
    },
    [subject, msgBody, resourceUploadId]
  );

  // Go to next/previous item
  const nextItem = useCallback(() => {
    const newItem =
      currentItem + 1 >= selectedItems.length ? 0 : currentItem + 1;
    setCurrentItem(newItem);
  }, [currentItem, selectedItems]);

  const previousItem = useCallback(() => {
    const prevItem =
      currentItem - 1 < 0 ? selectedItems.length - 1 : currentItem - 1;
    setCurrentItem(prevItem);
  }, [currentItem, selectedItems]);

  // Preview current item whenver index has changed
  useEffect(() => {
    if (showDialog) {
      previewItem(selectedItems[currentItem]);
    }
  }, [selectedItems, currentItem, previewItem, showDialog]);

  return (
    <Dialog
      fullWidth
      open={showDialog}
      aria-label={`Preview Email`}
      maxWidth="md"
      onClose={(event, reason) => {
        if (reason === 'backdropClick') return null;
        handleDialogToggle();
      }}
    >
      <DialogTitleWithCloseButton onClose={handleDialogToggle}>
        {'Preview Email'}
      </DialogTitleWithCloseButton>
      <DialogContent>
        <Grid container>
          {selectedItems.length === 0 ? (
            <span>
              No contacts are selected. Please select some contacts before see
              the Preview email.
            </span>
          ) : (
            <>
              <Grid item xs={12}>
                <TextField
                  value={substitutedSubject}
                  label="Subject:"
                  disabled
                />
              </Grid>

              <Grid item xs={12}>
                <Labeled label="Body:">
                  <CKEditor
                    data={substitutedBody}
                    readOnly
                    name="body"
                    config={RichTextInput.defaultProps.editorConfig}
                  />
                </Labeled>
              </Grid>
            </>
          )}
        </Grid>
      </DialogContent>
      {selectedItems.length === 0 ? (
        <></>
      ) : (
        <DialogActions>
          <div style={{ flexGrow: 1 }}>
            {`${item.firstName} ${item.lastName} / ${item.fundName}`}
          </div>
          {loading && <CircularProgress size={25} thickness={2} />}
          {`Contact: ${indexOf(selectedItems, item) + 1} of ${
            selectedItems.length
          }`}
          <Button onClick={previousItem}>Previous</Button>
          <Button onClick={nextItem}>Next</Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default EmailPreviewDialog;
